module.exports = __webpack_public_path__ + "img/on-chain.7be53cc1.png";